import { normalizeString } from '@/utils/stringUtils';
import { getStatusMetadata } from '@/features/Vacations/vacations.definitions';
import type {
    ApprovalCounts,
    ApprovalItem,
    ApprovalSortOrder,
    ApprovalTypeFilter,
} from '../approvals.types';

function rankOf(item: ApprovalItem): number {
    return item.kind === 'vacation' ? getStatusMetadata(item.item.request.status).rank : 0;
}

export function sortApprovals(items: ApprovalItem[], order: ApprovalSortOrder = 'newest'): ApprovalItem[] {
    const direction = order === 'newest' ? -1 : 1;

    return [...items].sort((a, b) => {
        const timeA = a.requestedAt?.getTime() ?? 0;
        const timeB = b.requestedAt?.getTime() ?? 0;
        if (timeA !== timeB) return (timeA - timeB) * direction;

        return rankOf(a) - rankOf(b);
    });
}

export function filterApprovals(
    items: ApprovalItem[],
    search: string,
    type: ApprovalTypeFilter
): ApprovalItem[] {
    const term = normalizeString(search);

    return items.filter((item) => {
        if (type !== 'all' && item.kind !== type) return false;
        if (!term) return true;
        return normalizeString(`${item.collaboratorName} ${item.collaboratorEmail}`).includes(term);
    });
}

export function countPendingByKind(items: ApprovalItem[]): ApprovalCounts {
    const counts: ApprovalCounts = { all: 0, vacation: 0, day_off: 0 };
    items.forEach((item) => {
        if (!item.isPending) return;
        counts.all += 1;
        counts[item.kind] += 1;
    });
    return counts;
}

export function findOldestPending(items: ApprovalItem[]): Date | null {
    const dates = items
        .filter((item) => item.isPending)
        .map((item) => item.requestedAt)
        .filter((date): date is Date => Boolean(date));

    if (dates.length === 0) return null;
    return dates.reduce((oldest, date) => (date < oldest ? date : oldest));
}
